import React from 'react';
import Modal, { Prompt, ModalFooter, ModalHeader } from '@ingka/modal';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import { hideError } from '../reducers/error/errorReducer';
import { useStateDispatch, useStateSelector } from '../store/';

const ErrorModal: React.FC = () => {
  const dispatch = useStateDispatch();
  const { t } = useTranslation();
  const title = useStateSelector((state) => state.error.title);
  const description = useStateSelector((state) => state.error.description);
  const buttonText = useStateSelector((state) => state.error.button);
  const showError = useStateSelector((state) => state.error.show);

  const clearError = (): void => {
    // Clear error state after modal has finished the closing animation.
    dispatch(hideError());
  };

  const footer = (
    <ModalFooter>
      <Button text={buttonText} type="primary" data-cy="error-modal-button" />
    </ModalFooter>
  );

  return showError ? (
    <Modal visible={showError} handleCloseBtn={clearError}>
      <Prompt
        titleId="modalErrorTitleId"
        title={title}
        footer={footer}
        header={
          <ModalHeader ariaCloseTxt={t('components.errorModal.ariaCloseTxt')} />
        }
      >
        <Text tagName="p" textStyle="Body.L">
          {description}
        </Text>
      </Prompt>
    </Modal>
  ) : null;
};

export default ErrorModal;
